import type { ReactNode } from 'react';

import { AppShell } from './components/AppShell';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicLayout } from './components/PublicLayout';
import { AcceptableUsePage, ConnectPhonePage, DeleteAccountPage, HelpPage, PrivacyPage, TermsPage } from './pages/InfoPages';
import { AuthPage } from './pages/AuthPage';
import { BillingPage } from './pages/BillingPage';
import { CampaignsPage } from './pages/CampaignsPage';
import { ComposePage } from './pages/ComposePage';
import { ConversationPage } from './pages/ConversationPage';
import { DevicesPage } from './pages/DevicesPage';
import { InboxPage } from './pages/InboxPage';
import { LandingPage } from './pages/LandingPage';
import { ForgotPasswordPage, ResetPasswordPage } from './pages/PasswordRecoveryPage';
import { SettingsPage } from './pages/SettingsPage';
import { Navigate, useLocation } from './router';

const publicPages: Record<string, ReactNode> = {
  '/': <LandingPage />, '/help': <HelpPage />, '/privacy': <PrivacyPage />, '/terms': <TermsPage />, '/acceptable-use': <AcceptableUsePage />, '/delete-account': <DeleteAccountPage />, '/connect-phone': <ConnectPhonePage />, '/forgot-password': <ForgotPasswordPage />, '/reset-password': <ResetPasswordPage />,
};

export function App() {
  const { pathname } = useLocation();
  if (pathname === '/login') return <AuthPage mode="login" />;
  if (pathname === '/register') return <AuthPage mode="register" />;
  if (pathname in publicPages) return <PublicLayout>{publicPages[pathname]}</PublicLayout>;
  if (pathname.startsWith('/app')) return <ProtectedRoute><AppShell>{appPage(pathname)}</AppShell></ProtectedRoute>;
  return <Navigate to="/" replace />;
}

function appPage(pathname: string): ReactNode {
  if (pathname === '/app' || pathname === '/app/') return <Navigate to="/app/inbox" replace />;
  if (pathname === '/app/inbox') return <InboxPage />;
  if (/^\/app\/conversations\/[^/]+$/.test(pathname)) return <ConversationPage />;
  if (pathname === '/app/compose') return <ComposePage />;
  if (pathname === '/app/campaigns') return <CampaignsPage />;
  if (pathname === '/app/devices') return <DevicesPage />;
  if (pathname === '/app/billing') return <BillingPage />;
  if (pathname === '/app/settings') return <SettingsPage />;
  return <Navigate to="/app/inbox" replace />;
}
